// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1dfve","bigColWidth":"Table_bigColWidth__1IE7o","biggerColWidth":"Table_biggerColWidth__2Ga6b","row":"Table_row__bes2B","col":"Table_col__3oFmf"};